import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '@app/shared/components';
import { Reason, ReasonScope } from '@models/reason.model';
import { ReasonsService } from '@services/reasons.service';

@Component({
    selector: 'app-ticket-on-hold-modal',
    templateUrl: './ticket-on-hold-modal.component.html',
    styleUrls: ['./ticket-on-hold-modal.component.scss']
})
export class TicketOnHoldModalComponent implements OnInit {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Output() confirmEvent = new EventEmitter<any>();

    onHoldForm: UntypedFormGroup;
    reasons: Reason[] = [];

    showValidations = false;

    constructor(private reasonsService: ReasonsService) { }

    ngOnInit() {
        this.onHoldForm = new UntypedFormGroup({
            reason: new UntypedFormControl('', Validators.required),
            description: new UntypedFormControl('', Validators.required)
        });
        this.getReasons();
    }

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.reset();
        this.modal.close();
    }

    onCancel() {
        this.close();
    }

    onConfirm() {
        if (this.onHoldForm.invalid) {
            this.showValidations = true;
            return;
        }

        this.confirmEvent.emit({
            reasonId: this.onHoldForm.value.reason,
            description: this.onHoldForm.value.description
        });
    }

    private getReasons() {
        this.reasonsService.getAllIReasons(null, ReasonScope.TicketOnHold).subscribe(
            (data: any) => this.reasons = data.items,
            () => this.reasons = []
        );
    }

    private reset() {
        this.showValidations = false;
        this.onHoldForm.reset();
    }

}
